$( document ).ready(function() {

    initVideoCover();

        $( window ).resize(function() {
          initVideoCover();
        });



        /* INIT VIDEOS */
        function initVideoCover() {
          var video = $('#coverVideo');
          var size;
          if (window.matchMedia('(max-width:580px), (orientation: portrait)').matches) {
            size = 'mobile';
          }
          // else if (window.matchMedia('(max-width:1280px)').matches) {
          //   size = 'small';
          // }
          // else if (window.matchMedia('(max-width:1920px)').matches) {
          //   size = 'medium';
          // }
          else {
            size = 'large';
          }

          video.append('<source src=\'' + $(video).data(size) + '\' type=\'video/mp4\'>');

        }

        /* END INIT VIDEOS */

});
